let language = {
    PRODUCT_SERVICE:"Products and Services:",
    PRICE_BREAKDOWN: "Price Breakdown",
    PRODUCT_COST: "Product Cost:",
    PRODUCT_PICKING_FEE: "Product Picking Fee:",
    PACK_IN_FULFILMENT: "Pack-in Fulfilment:",
    PACKAGING_MATERIALS: "Packaging Materials:",
    PRICE_BREAKDOWN_TIP: "* This breakdown of the {{appName}} product price is provided to ensure full transparency for all partners."
};

export { language }